import axios from 'axios';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus'


const router = useRouter()
const service = axios.create({
  // baseURL: '/dev-api', // 设置你的基本 URL //开发环境
  baseURL: '/prod-api', // 设置你的基本 URL //生产环境
  timeout: 5000, // 设置请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么，比如添加请求头
    config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('access_token'); // 添加请求头部分
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 对响应数据做些什么，比如统一处理状态码
    if (response.status === 401 || response.data.msg == "登录状态已过期") {
      ElMessage.error("登录状态已过期")
      // Redirect to the login page
      localStorage.removeItem("access_token")
      location.href = '/index';
      setTimeout(() => {
        location.reload();
      },1000)
    }
    return response;
  },
  (error) => {
    // 对响应错误做些什么
    return Promise.reject(error);
  }
);

export default service;